var TranslatorService = /** @class */ (function () {
    function TranslatorService(translate) {
        this.translate = translate;
        this.defaultLanguage = "en";
        this.availablelangs = [
            { code: "en", text: "English" },
            { code: "es", text: "Spanish" },
            { code: "pt", text: "Portuguese" },
            { code: "fr", text: "French" },
            { code: "de", text: "German" },
            { code: "nl", text: "Dutch" },
            { code: "ru", text: "Russian" },
            { code: "zh-cn", text: "Chinese Simplified" },
            { code: "zh-tw", text: "Chinese Traditional" },
            { code: "el", text: "Greek" }
        ];
        if (!translate.getDefaultLang())
            translate.setDefaultLang(this.defaultLanguage);
        this.useLanguage();
    }
    TranslatorService.prototype.useLanguage = function (lang) {
        if (lang === void 0) { lang = null; }
        this.translate.use(lang || this.translate.getDefaultLang());
    };
    TranslatorService.prototype.getAvailableLanguages = function () {
        return this.availablelangs;
    };
    return TranslatorService;
}());
export { TranslatorService };
